/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_All_Caught_UpInputs */

const en_dashboard_all_caught_up = /** @type {(inputs: Dashboard_All_Caught_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You are all caught up!`)
};

const pt_br2_dashboard_all_caught_up = /** @type {(inputs: Dashboard_All_Caught_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você está em dia!`)
};

/**
* | output |
* | --- |
* | "You are all caught up!" |
*
* @param {Dashboard_All_Caught_UpInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const dashboard_all_caught_up = /** @type {((inputs?: Dashboard_All_Caught_UpInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_All_Caught_UpInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dashboard_all_caught_up(inputs)
	return pt_br2_dashboard_all_caught_up(inputs)
});